import { database } from '@/firebase';

const {
  updateRecord,
  createRecord,
  deleteRecord,
} = database;

export default {
  createCharacter({ dispatch }, character) {
    return createRecord({
      model: 'characters',
      value: character,
    }).then(() => dispatch('fetch', { model: 'characters' }));
  },
  removeCharacter({ dispatch }, id) {
    return deleteRecord({
      model: 'characters',
      id,
    }).then(() => dispatch('fetch', { model: 'characters' }));
  },
  reorderCharacters({ commit }, characters) {
    commit('set', { model: 'characters', value: characters });
    characters.forEach((character) => {
      const { id, position } = character;
      updateRecord({
        model: 'characters',
        id,
        value: { position },
      });
    });
  },
};
